var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_circle_FILL1_wght400_GRAD0_opsz48",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_circle_FILL1_wght400_GRAD0_opsz48-2",
    "data-name": "account_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M84.438,195.531a17.775,17.775,0,0,1,3.891-1.891A13.117,13.117,0,0,1,92.5,193a13.262,13.262,0,0,1,4.188.641,17.651,17.651,0,0,1,3.906,1.891,10.971,10.971,0,0,0,1.953-3.406,11.294,11.294,0,0,0,.578-3.625,10.626,10.626,0,1,0-21.25,0,11.023,11.023,0,0,0,.594,3.625A11.246,11.246,0,0,0,84.438,195.531Zm8.057-6.094a4.226,4.226,0,1,1,3.047-1.234A4.123,4.123,0,0,1,92.494,189.438ZM92.487,201a12.212,12.212,0,0,1-4.884-.984,12.452,12.452,0,0,1-6.635-6.667A12.291,12.291,0,0,1,80,188.484a12.122,12.122,0,0,1,.984-4.864,12.507,12.507,0,0,1,2.688-3.964,12.83,12.83,0,0,1,3.979-2.672,12.511,12.511,0,0,1,9.729,0,12.494,12.494,0,0,1,6.636,6.641,12.5,12.5,0,0,1,0,9.726,12.838,12.838,0,0,1-2.672,3.977,12.48,12.48,0,0,1-3.973,2.688A12.212,12.212,0,0,1,92.487,201Z",
    transform: "translate(-80 -176)",
    fill: "#918f90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.608ca5b9fbfc67baff072225e36007a6.svg";
export { ForwardRef as ReactComponent };